import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cIf from 'classnames';

var tr = require('ts-translate-js').default.boundTR;

class UserEmails extends Component {
    createEmailValidationErrorMessage() {
        return (this.props.email != undefined && (this.props.email != this.props.emailValidation))
            ? <span id="helpBlock" className="help-block">{tr("profileedition.emailvalidationerror")}</span>
            : null;
    }

    handleOnEmailChange(e) {
        this.props.handleOnEmailsChange({
            email: e.target.value,
            emailValidation: this.props.emailValidation
        });
    }

    handleOnEmailValidationChange(e) {
        this.props.handleOnEmailsChange({
            email: this.props.email,
            emailValidation: e.target.value
        });
    }

    render() {
        var emailValidationErrorMessage = this.createEmailValidationErrorMessage();

        return (
            <div>
                <div className={cIf({ "has-error": (this.props.showProfileEditionError && this.props.email === "") || this.props.emailErrorMessage != null, "form-group": true })}>
                    <label htmlFor="inputEmail" className="control-label">{tr("profileinfo.email")}</label>
                    <input type="text" id="inputEmail" value={this.props.email} className="form-control" onChange={(e) => this.handleOnEmailChange(e)}></input>
                    {this.props.emailErrorMessage}
                </div>
                {this.props.isNew ? (
                <div className={cIf({ "has-error": (emailValidationErrorMessage != null), "form-group": true })}>
                    <label htmlFor="inputEmailValidation" className="control-label">{tr("profileinfo.emailvalidation")}</label>
                    <input type="text" id="inputEmailValidation" value={this.props.emailValidation} className="form-control" onChange={(e) => this.handleOnEmailValidationChange(e)}></input>
                    {emailValidationErrorMessage}
                </div>) : null}
            </div>
        )
    }
}

UserEmails.propTypes = {
    email: PropTypes.string,
    emailValidation: PropTypes.string,
    showProfileEditionError: PropTypes.bool,
    profileEditionError: PropTypes.object,
    handleOnEmailsChange: PropTypes.func
}

export default UserEmails;
